module.exports = __webpack_public_path__ + "612ddb0cb2e81de3b209d8089f610fba.pdf";